import React from 'react';

import { CircleAlert, CircleCheck, CircleX } from 'lucide-react';

import { getScoreColor } from '../../../../helpers/misc.helper';

import { ISimulationReportV1 } from '../../../../types/services.interface';

interface AnalysisV1ViewProps {
    report: ISimulationReportV1;
};
export const AnalysisV1View = ({ report }: AnalysisV1ViewProps) => {

    return (
        <div className='complete_data__analysis__v1'>
            <div className='complete_data__analysis__v1__overall_communication_profile'>
                <h5>Overall Communication Profile</h5>
                <p className='complete_data__analysis__v1__overall_communication_profile__content'>
                    {report.overall_communication_profile.content}
                </p>
                <p className={`complete_data__analysis__v1__overall_communication_profile__status complete_data__analysis__v1__overall_communication_profile__status__color_${report.overall_communication_profile.status}`}>
                    {report.overall_communication_profile.status[0].toUpperCase() + report.overall_communication_profile.status.slice(1)}
                </p>
            </div>
            <br />
            <div className='complete_data__analysis__v1__communication_dimensions'>
                <h5>Communication Dimensions</h5>
                <div className='complete_data__analysis__v1__communication_dimensions__list'>
                    {report.communication_dimensions.map((dimension) => (
                        <div
                            key={dimension.title}
                            className={`complete_data__analysis__v1__communication_dimensions__item complete_data__analysis__v1__communication_dimensions__item__color_${getScoreColor(dimension.score)}`}
                        >
                            <div className='complete_data__analysis__v1__communication_dimensions__item__top'>
                                <div className='complete_data__analysis__v1__communication_dimensions__item__top__content'>
                                    <h6>{dimension.title}</h6>
                                    <p>{dimension.description}</p>
                                </div>
                                <div className='complete_data__analysis__v1__communication_dimensions__item__top__score'>
                                    {
                                        dimension.score < 3
                                            ? <CircleX />
                                            : dimension.score < 5
                                                ? <CircleAlert />
                                                : <CircleCheck />
                                    }
                                    <h4>{dimension.score}/5</h4>
                                </div>
                            </div>
                            <div className='complete_data__analysis__v1__communication_dimensions__item__progress_bar'>
                                <div className='complete_data__analysis__v1__communication_dimensions__item__progress_bar__fill' style={{ width: `${(dimension.score / 5) * 100}%` }} />
                            </div>
                            <p className='complete_data__analysis__v1__communication_dimensions__item__report'>{dimension.report}</p>
                        </div>
                    ))}
                </div>
            </div>
            <br />
            <div className='complete_data__analysis__v1__future_recommendations'>
                <h5 className='mb-xl'>Recommendations for Future Conversations</h5>
                {report.future_recommendations.map((recommendation, idx) => (
                    <div
                        key={recommendation}
                        className='complete_data__analysis__v1__future_recommendations__item'
                    >
                        <div>{idx + 1}</div>
                        <p className='text-sm'>{recommendation}</p>
                    </div>
                ))}
            </div>
            <br />
            <div className='complete_data__analysis__v1__reflection_questions'>
                <h5 className='mb-xl'>Reflection Questions</h5>
                {report.reflection_questions.map((question) => (
                    <div
                        key={question.question}
                        className='complete_data__analysis__v1__reflection_questions__item'
                    >
                        <p className='text-sm'><strong>{question.question}</strong></p>
                        <p className='text-sm mt-xs'>{question.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};